import angular from 'angular';
import routinesListComponent from './routines-list.component';
import routinesListService from './routines-list.service';
import routinesListConfig from './routines-list.config';

let routinesListModule = angular.module('app.routinesList',[])
  .component('routinesList', routinesListComponent)
  .service('routinesListService', routinesListService)
  .config(routinesListConfig);

export default routinesListModule;






/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/routines-list/routines-list.js
 **/